import validUrl from 'valid-url';
import ModelService from './model.service';

const VimeoService = new ModelService('/vimeo', '/vimeo');

VimeoService.defaultLogo = '/img/youtube.png';

VimeoService.getLinkPreview = (link) => {
  if (validUrl.isUri(link)) return link;
  return VimeoService.defaultLogo;
};

export default VimeoService;



// WEBPACK FOOTER //
// ./src/services/vimeo.service.js